import styled from 'styled-components';
import { Row, Col } from 'antd';
import { Container } from '$app/shared/components/Container';

export const StyledContainer = styled(Container)`
  padding: 8px 36px;
  background: #fbfbfb;
  form {
    width: 600px;
  }
  h2 {
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 10px;
  }
  .ant-form-item {
    i.anticon-info-circle {
      margin-left: 10px;
    }
    .ant-input-number {
      width: 100%;
    }
    .ant-time-picker {
      width: 100%;
    }
    .ant-form-item-label {
      color: rgb(101, 103, 105) !important;
      width: 100% !important;
      text-align: left;
    }
    .ant-form-item-control-wrapper {
      width: 100% !important;
    }
    .ant-radio span {
      font-weight: normal;
    }
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
`;

export const StyledCapacityTable = styled.div`
  width: 100%;
  margin-bottom: 22px;
`;

export const DayProperty = styled.div`
  width: 100%;
  font-size: 13px;
  text-align: left;
  height: 40px;
  font-weight: 600;
  margin-bottom: 10px;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  display: flex;
  &:first-of-type {
    margin-top: 70px;
  }
`;

export const ErrorMessage = styled.div`
  color: red;
  font-size: 16px;
`;

export const Days = styled(Row)`
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
`;

export const DayColumn = styled(Col)`
  display: inline-block;
  float: none;
  vertical-align: top;
  padding: 0 5px;
  > * {
    display: block;
    width: 100%;
    text-align: center;
  }
  .ant-input-number,
  .ant-time-picker {
    padding: 0;
    margin-bottom: 10px;
    border-radius: 4px;
    height: 40px;
  }
  input {
    text-align: center;
    color: #32383e;
    border-radius: 4px;
    height: 40px;
    margin-bottom: 10px;
    &:disabled {
      color: #939699;
    }
  }
  .ant-input-number.error,
  .ant-time-picker.error input {
    border-color: #ff5858;
  }
`;

export const Heading = styled.div`
  width: 100%;
  background: #f5f6f6;
  border-radius: 4px;
  text-align: center;
  padding: 10px 26px;
  font-weight: 600;
  margin-bottom: 10px;
  &.today {
    background: #e3f0fb;
    color: #1791ff;
  }
`;

export const ClosedSlot = styled.div`
  width: 100%;
  height: 40px;
  background: #f5f6f6;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  margin: 10px;
  margin-left: 0;
  padding: 10px 0;
  &:before {
    content: 'Closed';
    color: #939699;
  }
`;
